import { get, post } from '@/http/request';
import { comBaseUrl } from '../config';
/**
 * @description: 市级考试系统
 * @author: star
 * @param {*} param
 * @return {*}
 */

// 获取考点列表
export function getExaminationPlaceList(param) {
  return get(`${comBaseUrl}/api/city/exam/getExaminationPlaceList`, param);
}

// 获取考点信息
export function getExaminationPlaceById(param) {
  // return get(`${comBaseUrl}/api/city/exam/getExaminationPlaceById`, param);
  return get(`${comBaseUrl}/api/city/exam/bigscreen/getExamPlaceById?id=` + param.id);
}

// 
export function getExaminationDataList(param) {
  return get(`${comBaseUrl}/api/city/exam/getExaminationDataList`, param);
}

/**
 * 获取移动设备
 * @returns 
 */ 
export function getDeviceList() {
  return get(`${comBaseUrl}/api/location/getDeviceList`);
}

/**
 * 获取移动设备2
 * @returns 
 */ 
export function getDeviceList2() {
  return get(`${comBaseUrl}/api/gps/location/getDeviceList`);
}

/**
 * 根据日期设备获取轨迹
 * @returns 
 */ 
export function getLocationListGroupByDevice(data) {
  return post(`${comBaseUrl}/api/location/getLocationListGroupByDevice`, data);
}

/**
 * 根据日期设备获取轨迹2
 * @returns 
 */ 
export function getLocationListGroupByDevice2(data) {
  return post(`${comBaseUrl}/api/gps/location/getLocationListGroupByDevice`, data);
}

export function getAllExamList() {
  return get(`${comBaseUrl}/api/city/exam/getAllExamList`);
}


export function getExamPlaceList(data) {
  return post(`${comBaseUrl}/api/city/exam/bigscreen/getExamPlaceList`, data);
}


export function getExamDataList(data) {
  return post(`${comBaseUrl}/api/city/exam/bigscreen/getExamDataList`, data);
}

export function getDeviceListByExam(data) {
  return post(`${comBaseUrl}/api/gps/location/getDeviceList`, data);
}


export function getVideoToken() {
  return post(`${comBaseUrl}/api/gps/location/getVideoToken`);
}

export function getVideoTokenFromRemoteServer() {
  return post(`${comBaseUrl}/api/gps/location/getVideoTokenFromRemoteServer`);
}

